import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modal, Grid, Card, Icon, Button } from 'semantic-ui-react';

import styles from './FieldTypeSelector.module.scss';

const FieldTypeSelector = React.memo(({ onSelect, onClose, activeIntegrations }) => {
  const baseFieldTypes = [
    { type: 'text', label: 'Text Input', icon: 'font', description: 'Single line text' },
    { type: 'textarea', label: 'Text Area', icon: 'align left', description: 'Multi-line text' },
    { type: 'number', label: 'Number', icon: 'hashtag', description: 'Numeric input' },
    { type: 'select', label: 'Dropdown', icon: 'dropdown', description: 'Select one option' },
    {
      type: 'radio',
      label: 'Radio Buttons',
      icon: 'dot circle outline',
      description: 'Choose one',
    },
    {
      type: 'checkbox',
      label: 'Checkboxes',
      icon: 'check square outline',
      description: 'Select multiple',
    },
    { type: 'date', label: 'Date', icon: 'calendar', description: 'Date picker' },
    { type: 'time', label: 'Time', icon: 'clock outline', description: 'Time picker' },
    { type: 'camera', label: 'Camera/Photo', icon: 'camera', description: 'Take or upload photo' },
    { type: 'signature', label: 'Signature', icon: 'pencil', description: 'Digital signature' },
    {
      type: 'static_text',
      label: 'Info/Instructions',
      icon: 'info circle',
      description: 'Display text only',
    },
    {
      type: 'link',
      label: 'Link',
      icon: 'linkify',
      description: 'Display a hyperlink',
    },
    {
      type: 'card_extraction',
      label: 'Extract from Description',
      icon: 'magic',
      description: 'Auto-fill from Card Description',
    },
  ];

  const integrationFieldTypes = useMemo(() => {
    const items = [];
    if ((activeIntegrations || []).includes('wheelbase')) {
      items.push(
        {
          type: 'wheelbase_vehicle',
          label: 'Wheelbase Vehicle',
          icon: 'car',
          description: 'Search select vehicle (name/VIN)',
        },
        {
          type: 'wheelbase_booking',
          label: 'Wheelbase Booking',
          icon: 'clipboard list',
          description: 'Search select booking (ID/Renter)',
        }
      );
    }
    return items;
  }, [activeIntegrations]);

  const fieldTypes = [...baseFieldTypes, ...integrationFieldTypes];

  return (
    <Modal open onClose={onClose} size="large">
      <Modal.Header>
        <Icon name="add" />
        Select Field Type
      </Modal.Header>
      <Modal.Content>
        <Grid className={styles.typeGrid}>
          {fieldTypes.map(fieldType => (
            <Grid.Column key={fieldType.type} mobile={8} tablet={4} computer={4}>
              <Card className={styles.typeCard} onClick={() => onSelect(fieldType.type)}>
                <Card.Content className={styles.typeContent}>
                  <div className={styles.typeIcon}>
                    <Icon name={fieldType.icon} size="huge" />
                  </div>
                  <Card.Header className={styles.typeLabel}>{fieldType.label}</Card.Header>
                  <Card.Description className={styles.typeDescription}>
                    {fieldType.description}
                  </Card.Description>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))}
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Cancel</Button>
      </Modal.Actions>
    </Modal>
  );
});

FieldTypeSelector.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  activeIntegrations: PropTypes.arrayOf(PropTypes.string),
};

FieldTypeSelector.defaultProps = {
  activeIntegrations: [],
};

export default FieldTypeSelector;
